import { SegnalazioneChoiceList } from "../models/objs/SegnalazioneChoiceList";

const SegnalazioneChoiceLists: SegnalazioneChoiceList = {
    formaGiuridica: [
        {
            id: 1,
            name: "S.p.A."
        },
        {
            id: 2,
            name: "S.r.l."
        },
        {
            id: 3,
            name: "S.a.s."
        }
    ],
    // fusoOrario: [
    //     {
    //         id: "UTC",
    //         name: "Universal Coordinated Time (UTC)"
    //     },
    //     {
    //         id: "GMT",
    //         name: "GMT (Greenwich Mean Time) (UTC)"
    //     },
    //     {
    //         id: "ECT",
    //         name: "European Central Time (UTC+1:00)"
    //     },
    //     {
    //         id: "EET",
    //         name: "EET (Eastern European Time) (UTC+2:00)"
    //     },
    //     {
    //         id: "ART",
    //         name: "ART (Egypt Standard Time Arabic) (UTC+2:00)"
    //     },
    //     {
    //         id: "EAT",
    //         name: "Eastern African Time (UTC+3:00)"
    //     },
    //     {
    //         id: "MET",
    //         name: "Middle East Time (UTC+3:30)"
    //     },
    //     {
    //         id: "NET",
    //         name: "Near East Time (UTC+4:00)"
    //     },
    //     {
    //         id: "PLT",
    //         name: "Pakistan Lahore Time (UTC+5:00)"
    //     },
    //     {
    //         id: "IST",
    //         name: "India Standard Time (UTC+5:30)"
    //     },
    //     {
    //         id: "BST",
    //         name: "Bangladesh Standard Time (UTC+6:00)"
    //     },
    //     {
    //         id: "VST",
    //         name: "Vietnam Standard Time (UTC+7:00)"
    //     },
    //     {
    //         id: "CTT",
    //         name: "China Taiwan Time (UTC+8:00)"
    //     },
    //     {
    //         id: "JST",
    //         name: "Japan Standard Time (UTC+9:00)"
    //     },
    //     {
    //         id: "ACT",
    //         name: "Australia Central Time (UTC+9:30)"
    //     },
    //     {
    //         id: "AET",
    //         name: "Australia Eastern Time (UTC+10:00)"
    //     },
    //     {
    //         id: "SST",
    //         name: "Solomon Standard Time (UTC+11:00)"
    //     },
    //     {
    //         id: "NST",
    //         name: "New Zealand Standard Time (UTC+12:00)"
    //     },
    //     {
    //         id: "MIT",
    //         name: "Midway Islands Time (UTC-11:00)"
    //     },
    //     {
    //         id: "HST",
    //         name: "Hawaii Standard Time (UTC-10:00)"
    //     },
    //     {
    //         id: "AST",
    //         name: "Alaska Standard Time (UTC-9:00)"
    //     },
    //     {
    //         id: "PST",
    //         name: "Pacific Standard Time (UTC-8:00)"
    //     },
    //     {
    //         id: "PNT",
    //         name: "Phoenix Standard Time (UTC-7:00)"
    //     },
    //     {
    //         id: "MST",
    //         name: "Mountain Standard Time (UTC-7:00)"
    //     },
    //     {
    //         id: "CST",
    //         name: "Central Standard Time (UTC-6:00)"
    //     },
    //     {
    //         id: "EST",
    //         name: "Eastern Standard Time (UTC-5:00)"
    //     },
    //     {
    //         id: "IET",
    //         name: "Indiana Eastern Standard Time (UTC-5:00)"
    //     },
    //     {
    //         id: "PRT",
    //         name: "Puerto Rico and US Virgin Islands Time (UTC-4:00)"
    //     },
    //     {
    //         id: "CNT",
    //         name: "Canada Newfoundland Time (UTC-3:30)"
    //     },
    //     {
    //         id: "AGT",
    //         name: "Argentina Standard Time (UTC-3:00)"
    //     },
    //     {
    //         id: "BET",
    //         name: "Brazil Eastern Time (UTC-3:00)"
    //     },
    //     {
    //         id: "CAT",
    //         name: "Central African Time (UTC-1:00)"
    //     }
    // ],
    naturaSospetto: [
        {
            id: 1,
            name: "Insider trading"
        },
        {
            id: 2,
            name: "Tentato Insider trading"
        },
        {
            id: 3,
            name: "Manipolazione operativa"
        },
        {
            id: 4,
            name: "Tentata Manipolazione operativa"
        },
        {
            id: 5,
            name: "Manipolazione informativa"
        },
        {
            id: 6,
            name: "Insider trading & Manipolazione"
        },
        {
            id: 7,
            name: "Altro - Generico"
        },
        {
            id: 8,
            name: "Altro - Tipping"
        },
        // {
        //     id: 9,
        //     name: "Front running"
        // },
        // {
        //     id: 10,
        //     name: "Non presente"
        // },
        // {
        //     id: 11,
        //     name: "Non abuso di mercato"
        // }
    ],
    nazione: [
        {
            id: 1,
            name: "Afghanistan"
        },
        {
            id: 2,
            name: "Albania"
        },
        {
            id: 3,
            name: "Algeria"
        },
        {
            id: 4,
            name: "American Samoa"
        },
        {
            id: 5,
            name: "Andorra"
        },
        {
            id: 6,
            name: "Angola"
        },
        {
            id: 7,
            name: "Anguilla"
        },
        {
            id: 8,
            name: "Antarctica"
        },
        {
            id: 9,
            name: "Antigua and Barbuda"
        },
        {
            id: 10,
            name: "Argentina"
        },
        {
            id: 11,
            name: "Armenia"
        },
        {
            id: 12,
            name: "Aruba"
        },
        {
            id: 13,
            name: "Australia"
        },
        {
            id: 14,
            name: "Austria"
        },
        {
            id: 15,
            name: "Azerbaijan"
        },
        {
            id: 16,
            name: "Bahamas"
        },
        {
            id: 17,
            name: "Bahrain"
        },
        {
            id: 18,
            name: "Bangladesh"
        },
        {
            id: 19,
            name: "Barbados"
        },
        {
            id: 20,
            name: "Belarus"
        },
        {
            id: 21,
            name: "Belgium"
        },
        {
            id: 22,
            name: "Belize"
        },
        {
            id: 23,
            name: "Benin"
        },
        {
            id: 24,
            name: "Bermuda"
        },
        {
            id: 25,
            name: "Bhutan"
        },
        {
            id: 26,
            name: "Bolivia"
        },
        {
            id: 27,
            name: "Bosnia and Herzegovina"
        },
        {
            id: 28,
            name: "Botswana"
        },
        {
            id: 29,
            name: "Bouvet Island"
        },
        {
            id: 30,
            name: "Brazil"
        },
        {
            id: 31,
            name: "British Indian Ocean Territory"
        },
        {
            id: 32,
            name: "Brunei Darussalam"
        },
        {
            id: 33,
            name: "Bulgaria"
        },
        {
            id: 34,
            name: "Burkina Faso"
        },
        {
            id: 35,
            name: "Burundi"
        },
        {
            id: 36,
            name: "Cambodia"
        },
        {
            id: 37,
            name: "Cameroon"
        },
        {
            id: 38,
            name: "Canada"
        },
        {
            id: 39,
            name: "Cape Verde"
        },
        {
            id: 40,
            name: "Cayman Islands"
        },
        {
            id: 41,
            name: "Central African Republic"
        },
        {
            id: 42,
            name: "Chad"
        },
        {
            id: 43,
            name: "Chile"
        },
        {
            id: 44,
            name: "China"
        },
        {
            id: 45,
            name: "Christmas Island"
        },
        {
            id: 46,
            name: "Cocos (Keeling) Islands"
        },
        {
            id: 47,
            name: "Colombia"
        },
        {
            id: 48,
            name: "Comoros"
        },
        {
            id: 49,
            name: "Congo"
        },
        {
            id: 50,
            name: "Congo, the Democratic Republic of the"
        },
        {
            id: 51,
            name: "Cook Islands"
        },
        {
            id: 52,
            name: "Costa Rica"
        },
        {
            id: 53,
            name: "Cote D'Ivoire"
        },
        {
            id: 54,
            name: "Croatia"
        },
        {
            id: 55,
            name: "Cuba"
        },
        {
            id: 56,
            name: "Cyprus"
        },
        {
            id: 57,
            name: "Czech Republic"
        },
        {
            id: 58,
            name: "Denmark"
        },
        {
            id: 59,
            name: "Djibouti"
        },
        {
            id: 60,
            name: "Dominica"
        },
        {
            id: 61,
            name: "Dominican Republic"
        },
        {
            id: 62,
            name: "Ecuador"
        },
        {
            id: 63,
            name: "Egypt"
        },
        {
            id: 64,
            name: "El Salvador"
        },
        {
            id: 65,
            name: "Equatorial Guinea"
        },
        {
            id: 66,
            name: "Eritrea"
        },
        {
            id: 67,
            name: "Estonia"
        },
        {
            id: 68,
            name: "Ethiopia"
        },
        {
            id: 69,
            name: "Falkland Islands (Malvinas)"
        },
        {
            id: 70,
            name: "Faroe Islands"
        },
        {
            id: 71,
            name: "Fiji"
        },
        {
            id: 72,
            name: "Finland"
        },
        {
            id: 73,
            name: "France"
        },
        {
            id: 74,
            name: "French Guiana"
        },
        {
            id: 75,
            name: "French Polynesia"
        },
        {
            id: 76,
            name: "French Southern Territories"
        },
        {
            id: 77,
            name: "Gabon"
        },
        {
            id: 78,
            name: "Gambia"
        },
        {
            id: 79,
            name: "Georgia"
        },
        {
            id: 80,
            name: "Germany"
        },
        {
            id: 81,
            name: "Ghana"
        },
        {
            id: 82,
            name: "Gibraltar"
        },
        {
            id: 83,
            name: "Greece"
        },
        {
            id: 84,
            name: "Greenland"
        },
        {
            id: 85,
            name: "Grenada"
        },
        {
            id: 86,
            name: "Guadeloupe"
        },
        {
            id: 87,
            name: "Guam"
        },
        {
            id: 88,
            name: "Guatemala"
        },
        {
            id: 89,
            name: "Guinea"
        },
        {
            id: 90,
            name: "Guinea-Bissau"
        },
        {
            id: 91,
            name: "Guyana"
        },
        {
            id: 92,
            name: "Haiti"
        },
        {
            id: 93,
            name: "Heard Island and Mcdonald Islands"
        },
        {
            id: 94,
            name: "Holy See (Vatican City State)"
        },
        {
            id: 95,
            name: "Honduras"
        },
        {
            id: 96,
            name: "Hong Kong"
        },
        {
            id: 97,
            name: "Hungary"
        },
        {
            id: 98,
            name: "Iceland"
        },
        {
            id: 99,
            name: "India"
        },
        {
            id: 100,
            name: "Indonesia"
        },
        {
            id: 101,
            name: "Iran, Islamic Republic of"
        },
        {
            id: 102,
            name: "Iraq"
        },
        {
            id: 103,
            name: "Ireland"
        },
        {
            id: 104,
            name: "Israel"
        },
        {
            id: 105,
            name: "Italy"
        },
        {
            id: 106,
            name: "Jamaica"
        },
        {
            id: 107,
            name: "Japan"
        },
        {
            id: 108,
            name: "Jordan"
        },
        {
            id: 109,
            name: "Kazakhstan"
        },
        {
            id: 110,
            name: "Kenya"
        },
        {
            id: 111,
            name: "Kiribati"
        },
        {
            id: 112,
            name: "Korea, Democratic People's Republic of"
        },
        {
            id: 113,
            name: "Korea, Republic of"
        },
        {
            id: 114,
            name: "Kuwait"
        },
        {
            id: 115,
            name: "Kyrgyzstan"
        },
        {
            id: 116,
            name: "Lao People's Democratic Republic"
        },
        {
            id: 117,
            name: "Latvia"
        },
        {
            id: 118,
            name: "Lebanon"
        },
        {
            id: 119,
            name: "Lesotho"
        },
        {
            id: 120,
            name: "Liberia"
        },
        {
            id: 121,
            name: "Libyan Arab Jamahiriya"
        },
        {
            id: 122,
            name: "Liechtenstein"
        },
        {
            id: 123,
            name: "Lithuania"
        },
        {
            id: 124,
            name: "Luxembourg"
        },
        {
            id: 125,
            name: "Macao"
        },
        {
            id: 126,
            name: "Macedonia, the Former Yugoslav Republic of"
        },
        {
            id: 127,
            name: "Madagascar"
        },
        {
            id: 128,
            name: "Malawi"
        },
        {
            id: 129,
            name: "Malaysia"
        },
        {
            id: 130,
            name: "Maldives"
        },
        {
            id: 131,
            name: "Mali"
        },
        {
            id: 132,
            name: "Malta"
        },
        {
            id: 133,
            name: "Marshall Islands"
        },
        {
            id: 134,
            name: "Martinique"
        },
        {
            id: 135,
            name: "Mauritania"
        },
        {
            id: 136,
            name: "Mauritius"
        },
        {
            id: 137,
            name: "Mayotte"
        },
        {
            id: 138,
            name: "Mexico"
        },
        {
            id: 139,
            name: "Micronesia, Federated States of"
        },
        {
            id: 140,
            name: "Moldova, Republic of"
        },
        {
            id: 141,
            name: "Monaco"
        },
        {
            id: 142,
            name: "Mongolia"
        },
        {
            id: 143,
            name: "Montserrat"
        },
        {
            id: 144,
            name: "Morocco"
        },
        {
            id: 145,
            name: "Mozambique"
        },
        {
            id: 146,
            name: "Myanmar"
        },
        {
            id: 147,
            name: "Namibia"
        },
        {
            id: 148,
            name: "Nauru"
        },
        {
            id: 149,
            name: "Nepal"
        },
        {
            id: 150,
            name: "Netherlands"
        },
        {
            id: 151,
            name: "Netherlands Antilles"
        },
        {
            id: 152,
            name: "New Caledonia"
        },
        {
            id: 153,
            name: "New Zealand"
        },
        {
            id: 154,
            name: "Nicaragua"
        },
        {
            id: 155,
            name: "Niger"
        },
        {
            id: 156,
            name: "Nigeria"
        },
        {
            id: 157,
            name: "Niue"
        },
        {
            id: 158,
            name: "Norfolk Island"
        },
        {
            id: 159,
            name: "Northern Mariana Islands"
        },
        {
            id: 160,
            name: "Norway"
        },
        {
            id: 161,
            name: "Oman"
        },
        {
            id: 162,
            name: "Pakistan"
        },
        {
            id: 163,
            name: "Palau"
        },
        {
            id: 164,
            name: "Palestinian Territory, Occupied"
        },
        {
            id: 165,
            name: "Panama"
        },
        {
            id: 166,
            name: "Papua New Guinea"
        },
        {
            id: 167,
            name: "Paraguay"
        },
        {
            id: 168,
            name: "Peru"
        },
        {
            id: 169,
            name: "Philippines"
        },
        {
            id: 170,
            name: "Pitcairn"
        },
        {
            id: 171,
            name: "Poland"
        },
        {
            id: 172,
            name: "Portugal"
        },
        {
            id: 173,
            name: "Puerto Rico"
        },
        {
            id: 174,
            name: "Qatar"
        },
        {
            id: 175,
            name: "Reunion"
        },
        {
            id: 176,
            name: "Romania"
        },
        {
            id: 177,
            name: "Russian Federation"
        },
        {
            id: 178,
            name: "Rwanda"
        },
        {
            id: 179,
            name: "Saint Helena"
        },
        {
            id: 180,
            name: "Saint Kitts and Nevis"
        },
        {
            id: 181,
            name: "Saint Lucia"
        },
        {
            id: 182,
            name: "Saint Pierre and Miquelon"
        },
        {
            id: 183,
            name: "Saint Vincent and the Grenadines"
        },
        {
            id: 184,
            name: "Samoa"
        },
        {
            id: 185,
            name: "San Marino"
        },
        {
            id: 186,
            name: "Sao Tome and Principe"
        },
        {
            id: 187,
            name: "Saudi Arabia"
        },
        {
            id: 188,
            name: "Senegal"
        },
        {
            id: 189,
            name: "Serbia and Montenegro"
        },
        {
            id: 190,
            name: "Seychelles"
        },
        {
            id: 191,
            name: "Sierra Leone"
        },
        {
            id: 192,
            name: "Singapore"
        },
        {
            id: 193,
            name: "Slovakia"
        },
        {
            id: 194,
            name: "Slovenia"
        },
        {
            id: 195,
            name: "Solomon Islands"
        },
        {
            id: 196,
            name: "Somalia"
        },
        {
            id: 197,
            name: "South Africa"
        },
        {
            id: 198,
            name: "South Georgia and the South Sandwich Islands"
        },
        {
            id: 199,
            name: "Spain"
        },
        {
            id: 200,
            name: "Sri Lanka"
        },
        {
            id: 201,
            name: "Sudan"
        },
        {
            id: 202,
            name: "Suriname"
        },
        {
            id: 203,
            name: "Svalbard and Jan Mayen"
        },
        {
            id: 204,
            name: "Swaziland"
        },
        {
            id: 205,
            name: "Sweden"
        },
        {
            id: 206,
            name: "Switzerland"
        },
        {
            id: 207,
            name: "Syrian Arab Republic"
        },
        {
            id: 208,
            name: "Taiwan, Province of China"
        },
        {
            id: 209,
            name: "Tajikistan"
        },
        {
            id: 210,
            name: "Tanzania, United Republic of"
        },
        {
            id: 211,
            name: "Thailand"
        },
        {
            id: 212,
            name: "Timor-Leste"
        },
        {
            id: 213,
            name: "Togo"
        },
        {
            id: 214,
            name: "Tokelau"
        },
        {
            id: 215,
            name: "Tonga"
        },
        {
            id: 216,
            name: "Trinidad and Tobago"
        },
        {
            id: 217,
            name: "Tunisia"
        },
        {
            id: 218,
            name: "Turkey"
        },
        {
            id: 219,
            name: "Turkmenistan"
        },
        {
            id: 220,
            name: "Turks and Caicos Islands"
        },
        {
            id: 221,
            name: "Tuvalu"
        },
        {
            id: 222,
            name: "Uganda"
        },
        {
            id: 223,
            name: "Ukraine"
        },
        {
            id: 224,
            name: "United Arab Emirates"
        },
        {
            id: 225,
            name: "United Kingdom"
        },
        {
            id: 226,
            name: "United States"
        },
        {
            id: 227,
            name: "United States Minor Outlying Islands"
        },
        {
            id: 228,
            name: "Uruguay"
        },
        {
            id: 229,
            name: "Uzbekistan"
        },
        {
            id: 230,
            name: "Vanuatu"
        },
        {
            id: 231,
            name: "Venezuela"
        },
        {
            id: 232,
            name: "Viet Nam"
        },
        {
            id: 233,
            name: "Virgin Islands, British"
        },
        {
            id: 234,
            name: "Virgin Islands, U.s."
        },
        {
            id: 235,
            name: "Wallis and Futuna"
        },
        {
            id: 236,
            name: "Western Sahara"
        },
        {
            id: 237,
            name: "Yemen"
        },
        {
            id: 238,
            name: "Zambia"
        },
        {
            id: 239,
            name: "Zimbabwe"
        }
    ],
    fuoriSede: [
        {
            id: 1,
            name: "Si"
        },
        {
            id: 2,
            name: "No"
        }
    ],
    provincia: [
        {
            id: 1,
            name: "Torino"
        },
        {
            id: 2,
            name: "Vercelli"
        },
        {
            id: 3,
            name: "Novara"
        },
        {
            id: 4,
            name: "Cuneo"
        },
        {
            id: 5,
            name: "Asti"
        },
        {
            id: 6,
            name: "Alessandria"
        },
        {
            id: 7,
            name: "Valle d'Aosta / Vallée d'Aoste"
        },
        {
            id: 8,
            name: "Imperia"
        },
        {
            id: 9,
            name: "Savona"
        },
        {
            id: 10,
            name: "Genova"
        },
        {
            id: 11,
            name: "La Spezia"
        },
        {
            id: 12,
            name: "Varese"
        },
        {
            id: 13,
            name: "Como"
        },
        {
            id: 14,
            name: "Sondrio"
        },
        {
            id: 15,
            name: "Milano"
        },
        {
            id: 16,
            name: "Bergamo"
        },
        {
            id: 17,
            name: "Brescia"
        },
        {
            id: 18,
            name: "Pavia"
        },
        {
            id: 19,
            name: "Cremona"
        },
        {
            id: 20,
            name: "Mantova"
        },
        {
            id: 21,
            name: "Bolzano / Bozen"
        },
        {
            id: 22,
            name: "Trento"
        },
        {
            id: 23,
            name: "Verona"
        },
        {
            id: 24,
            name: "Vicenza"
        },
        {
            id: 25,
            name: "Belluno"
        },
        {
            id: 26,
            name: "Treviso"
        },
        {
            id: 27,
            name: "Venezia"
        },
        {
            id: 28,
            name: "Padova"
        },
        {
            id: 29,
            name: "Rovigo"
        },
        {
            id: 30,
            name: "Udine"
        },
        {
            id: 31,
            name: "Gorizia"
        },
        {
            id: 32,
            name: "Trieste"
        },
        {
            id: 33,
            name: "Piacenza"
        },
        {
            id: 34,
            name: "Parma"
        },
        {
            id: 35,
            name: "Reggio nell'Emilia"
        },
        {
            id: 36,
            name: "Modena"
        },
        {
            id: 37,
            name: "Bologna"
        },
        {
            id: 38,
            name: "Ferrara"
        },
        {
            id: 39,
            name: "Ravenna"
        },
        {
            id: 40,
            name: "Forlì-Cesena"
        },
        {
            id: 41,
            name: "Pesaro e Urbino"
        },
        {
            id: 42,
            name: "Ancona"
        },
        {
            id: 43,
            name: "Macerata"
        },
        {
            id: 44,
            name: "Ascoli Piceno"
        },
        {
            id: 45,
            name: "Massa-Carrara"
        },
        {
            id: 46,
            name: "Lucca"
        },
        {
            id: 47,
            name: "Pistoia"
        },
        {
            id: 48,
            name: "Firenze"
        },
        {
            id: 49,
            name: "Livorno"
        },
        {
            id: 50,
            name: "Pisa"
        },
        {
            id: 51,
            name: "Arezzo"
        },
        {
            id: 52,
            name: "Siena"
        },
        {
            id: 53,
            name: "Grosseto"
        },
        {
            id: 54,
            name: "Perugia"
        },
        {
            id: 55,
            name: "Terni"
        },
        {
            id: 56,
            name: "Viterbo"
        },
        {
            id: 57,
            name: "Rieti"
        },
        {
            id: 58,
            name: "Roma"
        },
        {
            id: 59,
            name: "Latina"
        },
        {
            id: 60,
            name: "Frosinone"
        },
        {
            id: 61,
            name: "Caserta"
        },
        {
            id: 62,
            name: "Benevento"
        },
        {
            id: 63,
            name: "Napoli"
        },
        {
            id: 64,
            name: "Avellino"
        },
        {
            id: 65,
            name: "Salerno"
        },
        {
            id: 66,
            name: "L'Aquila"
        },
        {
            id: 67,
            name: "Teramo"
        },
        {
            id: 68,
            name: "Pescara"
        },
        {
            id: 69,
            name: "Chieti"
        },
        {
            id: 70,
            name: "Campobasso"
        },
        {
            id: 71,
            name: "Foggia"
        },
        {
            id: 72,
            name: "Bari"
        },
        {
            id: 73,
            name: "Taranto"
        },
        {
            id: 74,
            name: "Brindisi"
        },
        {
            id: 75,
            name: "Lecce"
        },
        {
            id: 76,
            name: "Potenza"
        },
        {
            id: 77,
            name: "Matera"
        },
        {
            id: 78,
            name: "Cosenza"
        },
        {
            id: 79,
            name: "Catanzaro"
        },
        {
            id: 80,
            name: "Reggio di Calabria"
        },
        {
            id: 81,
            name: "Trapani"
        },
        {
            id: 82,
            name: "Palermo"
        },
        {
            id: 83,
            name: "Messina"
        },
        {
            id: 84,
            name: "Agrigento"
        },
        {
            id: 85,
            name: "Caltanissetta"
        },
        {
            id: 86,
            name: "Enna"
        },
        {
            id: 87,
            name: "Catania"
        },
        {
            id: 88,
            name: "Ragusa"
        },
        {
            id: 89,
            name: "Siracusa"
        },
        {
            id: 90,
            name: "Sassari"
        },
        {
            id: 91,
            name: "Nuoro"
        },
        {
            id: 92,
            name: "Cagliari"
        },
        {
            id: 93,
            name: "Pordenone"
        },
        {
            id: 94,
            name: "Isernia"
        },
        {
            id: 95,
            name: "Oristano"
        },
        {
            id: 96,
            name: "Biella"
        },
        {
            id: 97,
            name: "Lecco"
        },
        {
            id: 98,
            name: "Lodi"
        },
        {
            id: 99,
            name: "Rimini"
        },
        {
            id: 100,
            name: "Prato"
        },
        {
            id: 101,
            name: "Crotone"
        },
        {
            id: 102,
            name: "Vibo Valentia"
        },
        {
            id: 103,
            name: "Verbano-Cusio-Ossola"
        },
        {
            id: 104,
            name: "Olbia-Tempio"
        },
        {
            id: 105,
            name: "Ogliastra"
        },
        {
            id: 106,
            name: "Medio Campidano"
        },
        {
            id: 107,
            name: "Carbonia-Iglesias"
        },
        {
            id: 108,
            name: "Monza e della Brianza"
        },
        {
            id: 109,
            name: "Fermo"
        },
        {
            id: 110,
            name: "Barletta-Andria-Trani"
        }
    ],
    regione: [
        {
            id: 1,
            name: "Piemonte"
        },
        {
            id: 2,
            name: "Valle d'Aosta"
        },
        {
            id: 3,
            name: "Lombardia"
        },
        {
            id: 4,
            name: "Trentino-Alto Adige"
        },
        {
            id: 5,
            name: "Veneto"
        },
        {
            id: 6,
            name: "Friuli-Venezia Giulia"
        },
        {
            id: 7,
            name: "Liguria"
        },
        {
            id: 8,
            name: "Emilia-Romagna"
        },
        {
            id: 9,
            name: "Toscana"
        },
        {
            id: 10,
            name: "Umbria"
        },
        {
            id: 11,
            name: "Marche"
        },
        {
            id: 12,
            name: "Lazio"
        },
        {
            id: 13,
            name: "Abruzzo"
        },
        {
            id: 14,
            name: "Molise"
        },
        {
            id: 15,
            name: "Campania"
        },
        {
            id: 16,
            name: "Puglia"
        },
        {
            id: 17,
            name: "Basilicata"
        },
        {
            id: 18,
            name: "Calabria"
        },
        {
            id: 19,
            name: "Sicilia"
        },
        {
            id: 20,
            name: "Sardegna"
        }
    ],
    tipoSoggettoSegnalante: [
        {
            id: 1,
            name: "Banca"
        },
        {
            id: 2,
            name: "Sim"
        },
        {
            id: 3,
            name: "SGR"
        },
        {
            id: 4,
            name: "Società di gestione di una sede regolamentata"
        },
        {
            id: 5,
            name: "Internalizzatore sistematico"
        },
        {
            id: 6,
            name: "Società non finanziaria"
        },
        {
            id: 7,
            name: "Fiduciaria"
        },
        {
            id: 8,
            name: "Altro"
        }
    ],
    vesteSegnalante: [
        {
            id : 1,
            name: "Conto Terzi"
        },
        {
            id : 2,
            name: "Conto Proprio"
        },
        {
            id : 3,
            name: "Gestore di sede di negoziazione"
        },
        {
            id : 4,
            name: "Internalizzatore sistematico"
        },
        {
            id : 5,
            name: "Altro (specificare nelle Note)"
        },
    ],
    catTipologiaNegoziazione: [
        {
            id: 1,
            name: "Market Making"
        },
        {
            id: 2,
            name: "Arbitraggio"
        }
    ],
    catTipologiaStrumNegoziato: [
        {
            id: 1,
            name: "Azioni"
        },
        {
            id: 2,
            name: "Derivati"
        },
        {
            id: 4,
            name: "Obbligazioni"
        },
        {
            id: 5,
            name: "Altro"
        },
        {
            id: 6,
            name: "Combinazione di più strumenti"
        },
        {
            id: 7,
            name: "ETPs / strutturati"
        }
    ]
}

export default SegnalazioneChoiceLists;

// const SegnalazioneChoiceLists = {
//     "formaGiuridica": [
//         {
//             "id": "40",
//             "label": "SPA"
//         },
//         {
//             "id": "41",
//             "label": "S.R.L"
//         },
//         {
//             "id": "42",
//             "label": "SM"
//         },
//         {
//             "id": "43",
//             "label": "S.A.S"
//         },
//         {
//             "id": "1",
//             "label": "CPA"
//         },
//         {
//             "id": "2",
//             "label": "CRL"
//         },
//         {
//             "id": "3",
//             "label": "COPA"
//         },
//         {
//             "id": "4",
//             "label": "CORL"
//         },
//         {
//             "id": "5",
//             "label": "EP"
//         },
//         {
//             "id": "6",
//             "label": "KK"
//         },
//         {
//             "id": "7",
//             "label": "SCARL"
//         },
//         {
//             "id": "8",
//             "label": "INC."
//         },
//         {
//             "id": "9",
//             "label": "LTD"
//         },
//         {
//             "id": "10",
//             "label": "SAPA"
//         },
//         {
//             "id": "11",
//             "label": "SNC"
//         },
//         {
//             "id": "12",
//             "label": "SICAV"
//         },
//         {
//             "id": "13",
//             "label": "SA"
//         },
//         {
//             "id": "14",
//             "label": "SPRL"
//         },
//         {
//             "id": "15",
//             "label": "SNC"
//         },
//         {
//             "id": "16",
//             "label": "PLC"
//         },
//         {
//             "id": "17",
//             "label": "BV"
//         },
//         {
//             "id": "18",
//             "label": "SICAF"
//         },
//         {
//             "id": "19",
//             "label": "SS"
//         },
//         {
//             "id": "20",
//             "label": "STP"
//         },
//         {
//             "id": "21",
//             "label": "NV"
//         },
//         {
//             "id": "22",
//             "label": "CORP"
//         },
//         {
//             "id": "23",
//             "label": "AS"
//         },
//         {
//             "id": "24",
//             "label": "GMBH"
//         },
//         {
//             "id": "25",
//             "label": "AG"
//         },
//         {
//             "id": "26",
//             "label": "DIPF"
//         },
//         {
//             "id": "27",
//             "label": "AB"
//         },
//         {
//             "id": "28",
//             "label": "OOO"
//         },
//         {
//             "id": "29",
//             "label": "SRO"
//         },
//         {
//             "id": "31",
//             "label": "SARL"
//         },
//         {
//             "id": "32",
//             "label": "LTD"
//         },
//         {
//             "id": "33",
//             "label": "LP"
//         },
//         {
//             "id": "34",
//             "label": "FON"
//         },
//         {
//             "id": "35",
//             "label": "SC"
//         },
//         {
//             "id": "36",
//             "label": "S.A."
//         },
//         {
//             "id": "37",
//             "label": "CO"
//         },
//         {
//             "id": "38",
//             "label": "SMA"
//         },
//         {
//             "id": "39",
//             "label": "SM"
//         },
//     ],
//     "fusoOrario": [
//         {
//             "id": "UTC",
//             "label": "Universal Coordinated Time (UTC)"
//         },
//         {
//             "id": "GMT",
//             "label": "GMT (Greenwich Mean Time) (UTC)"
//         },
//         {
//             "id": "ECT",
//             "label": "European Central Time (UTC+1:00)"
//         },
//         {
//             "id": "EET",
//             "label": "EET (Eastern European Time) (UTC+2:00)"
//         },
//         {
//             "id": "ART",
//             "label": "ART (Egypt Standard Time Arabic) (UTC+2:00)"
//         },
//         {
//             "id": "EAT",
//             "label": "Eastern African Time (UTC+3:00)"
//         },
//         {
//             "id": "MET",
//             "label": "Middle East Time (UTC+3:30)"
//         },
//         {
//             "id": "NET",
//             "label": "Near East Time (UTC+4:00)"
//         },
//         {
//             "id": "PLT",
//             "label": "Pakistan Lahore Time (UTC+5:00)"
//         },
//         {
//             "id": "IST",
//             "label": "India Standard Time (UTC+5:30)"
//         },
//         {
//             "id": "BST",
//             "label": "Bangladesh Standard Time (UTC+6:00)"
//         },
//         {
//             "id": "VST",
//             "label": "Vietnam Standard Time (UTC+7:00)"
//         },
//         {
//             "id": "CTT",
//             "label": "China Taiwan Time (UTC+8:00)"
//         },
//         {
//             "id": "JST",
//             "label": "Japan Standard Time (UTC+9:00)"
//         },
//         {
//             "id": "ACT",
//             "label": "Australia Central Time (UTC+9:30)"
//         },
//         {
//             "id": "AET",
//             "label": "Australia Eastern Time (UTC+10:00)"
//         },
//         {
//             "id": "SST",
//             "label": "Solomon Standard Time (UTC+11:00)"
//         },
//         {
//             "id": "NST",
//             "label": "New Zealand Standard Time (UTC+12:00)"
//         },
//         {
//             "id": "MIT",
//             "label": "Midway Islands Time (UTC-11:00)"
//         },
//         {
//             "id": "HST",
//             "label": "Hawaii Standard Time (UTC-10:00)"
//         },
//         {
//             "id": "AST",
//             "label": "Alaska Standard Time (UTC-9:00)"
//         },
//         {
//             "id": "PST",
//             "label": "Pacific Standard Time (UTC-8:00)"
//         },
//         {
//             "id": "PNT",
//             "label": "Phoenix Standard Time (UTC-7:00)"
//         },
//         {
//             "id": "MST",
//             "label": "Mountain Standard Time (UTC-7:00)"
//         },
//         {
//             "id": "CST",
//             "label": "Central Standard Time (UTC-6:00)"
//         },
//         {
//             "id": "EST",
//             "label": "Eastern Standard Time (UTC-5:00)"
//         },
//         {
//             "id": "IET",
//             "label": "Indiana Eastern Standard Time (UTC-5:00)"
//         },
//         {
//             "id": "PRT",
//             "label": "Puerto Rico and US Virgin Islands Time (UTC-4:00)"
//         },
//         {
//             "id": "CNT",
//             "label": "Canada Newfoundland Time (UTC-3:30)"
//         },
//         {
//             "id": "AGT",
//             "label": "Argentina Standard Time (UTC-3:00)"
//         },
//         {
//             "id": "BET",
//             "label": "Brazil Eastern Time (UTC-3:00)"
//         },
//         {
//             "id": "CAT",
//             "label": "Central African Time (UTC-1:00)"
//         }
//     ],
//     "naturaSospetto": [
//         {
//             "id": "1",
//             "label": "Manipolazione del mercato"
//         },
//         {
//             "id": "2",
//             "label": "Abuso di informazioni privilegiate"
//         },
//         {
//             "id": "3",
//             "label": "Tentata manipolazione del mercato"
//         },
//         {
//             "id": "4",
//             "label": "Abuso di informazioni privilegiate"
//         },
//         {
//             "id": "3",
//             "label": "Comunicazione illecita di informazioni"
//         },
//         // {
//         //     "id": "1",
//         //     "label": "Insider trading"
//         // },
//         // {
//         //     "id": "2",
//         //     "label": "Tentato Insider trading"
//         // },
//         // {
//         //     "id": "3",
//         //     "label": "Manipolazione operativa"
//         // },
//         // {
//         //     "id": "4",
//         //     "label": "Tentata Manipolazione operativa"
//         // },
//         // {
//         //     "id": "5",
//         //     "label": "Manipolazione informativa"
//         // },
//         // {
//         //     "id": "6",
//         //     "label": "Insider trading & Manipolazione"
//         // },
//         // {
//         //     "id": "7",
//         //     "label": "Altro - Generico"
//         // },
//         // {
//         //     "id": "8",
//         //     "label": "Altro - Tipping"
//         // },
//         // {
//         //     "id": "9",
//         //     "label": "Front running"
//         // },
//         // {
//         //     "id": "10",
//         //     "label": "Non presente"
//         // },
//         // {
//         //     "id": "11",
//         //     "label": "Non abuso di mercato"
//         // }
//     ],
//     "nazione": [
//         {
//             "id": "1",
//             "label": "Afghanistan"
//         },
//         {
//             "id": "2",
//             "label": "Albania"
//         },
//         {
//             "id": "3",
//             "label": "Algeria"
//         },
//         {
//             "id": "4",
//             "label": "American Samoa"
//         },
//         {
//             "id": "5",
//             "label": "Andorra"
//         },
//         {
//             "id": "6",
//             "label": "Angola"
//         },
//         {
//             "id": "7",
//             "label": "Anguilla"
//         },
//         {
//             "id": "8",
//             "label": "Antarctica"
//         },
//         {
//             "id": "9",
//             "label": "Antigua and Barbuda"
//         },
//         {
//             "id": "10",
//             "label": "Argentina"
//         },
//         {
//             "id": "11",
//             "label": "Armenia"
//         },
//         {
//             "id": "12",
//             "label": "Aruba"
//         },
//         {
//             "id": "13",
//             "label": "Australia"
//         },
//         {
//             "id": "14",
//             "label": "Austria"
//         },
//         {
//             "id": "15",
//             "label": "Azerbaijan"
//         },
//         {
//             "id": "16",
//             "label": "Bahamas"
//         },
//         {
//             "id": "17",
//             "label": "Bahrain"
//         },
//         {
//             "id": "18",
//             "label": "Bangladesh"
//         },
//         {
//             "id": "19",
//             "label": "Barbados"
//         },
//         {
//             "id": "20",
//             "label": "Belarus"
//         },
//         {
//             "id": "21",
//             "label": "Belgium"
//         },
//         {
//             "id": "22",
//             "label": "Belize"
//         },
//         {
//             "id": "23",
//             "label": "Benin"
//         },
//         {
//             "id": "24",
//             "label": "Bermuda"
//         },
//         {
//             "id": "25",
//             "label": "Bhutan"
//         },
//         {
//             "id": "26",
//             "label": "Bolivia"
//         },
//         {
//             "id": "27",
//             "label": "Bosnia and Herzegovina"
//         },
//         {
//             "id": "28",
//             "label": "Botswana"
//         },
//         {
//             "id": "29",
//             "label": "Bouvet Island"
//         },
//         {
//             "id": "30",
//             "label": "Brazil"
//         },
//         {
//             "id": "31",
//             "label": "British Indian Ocean Territory"
//         },
//         {
//             "id": "32",
//             "label": "Brunei Darussalam"
//         },
//         {
//             "id": "33",
//             "label": "Bulgaria"
//         },
//         {
//             "id": "34",
//             "label": "Burkina Faso"
//         },
//         {
//             "id": "35",
//             "label": "Burundi"
//         },
//         {
//             "id": "36",
//             "label": "Cambodia"
//         },
//         {
//             "id": "37",
//             "label": "Cameroon"
//         },
//         {
//             "id": "38",
//             "label": "Canada"
//         },
//         {
//             "id": "39",
//             "label": "Cape Verde"
//         },
//         {
//             "id": "40",
//             "label": "Cayman Islands"
//         },
//         {
//             "id": "41",
//             "label": "Central African Republic"
//         },
//         {
//             "id": "42",
//             "label": "Chad"
//         },
//         {
//             "id": "43",
//             "label": "Chile"
//         },
//         {
//             "id": "44",
//             "label": "China"
//         },
//         {
//             "id": "45",
//             "label": "Christmas Island"
//         },
//         {
//             "id": "46",
//             "label": "Cocos (Keeling) Islands"
//         },
//         {
//             "id": "47",
//             "label": "Colombia"
//         },
//         {
//             "id": "48",
//             "label": "Comoros"
//         },
//         {
//             "id": "49",
//             "label": "Congo"
//         },
//         {
//             "id": "50",
//             "label": "Congo, the Democratic Republic of the"
//         },
//         {
//             "id": "51",
//             "label": "Cook Islands"
//         },
//         {
//             "id": "52",
//             "label": "Costa Rica"
//         },
//         {
//             "id": "53",
//             "label": "Cote D'Ivoire"
//         },
//         {
//             "id": "54",
//             "label": "Croatia"
//         },
//         {
//             "id": "55",
//             "label": "Cuba"
//         },
//         {
//             "id": "56",
//             "label": "Cyprus"
//         },
//         {
//             "id": "57",
//             "label": "Czech Republic"
//         },
//         {
//             "id": "58",
//             "label": "Denmark"
//         },
//         {
//             "id": "59",
//             "label": "Djibouti"
//         },
//         {
//             "id": "60",
//             "label": "Dominica"
//         },
//         {
//             "id": "61",
//             "label": "Dominican Republic"
//         },
//         {
//             "id": "62",
//             "label": "Ecuador"
//         },
//         {
//             "id": "63",
//             "label": "Egypt"
//         },
//         {
//             "id": "64",
//             "label": "El Salvador"
//         },
//         {
//             "id": "65",
//             "label": "Equatorial Guinea"
//         },
//         {
//             "id": "66",
//             "label": "Eritrea"
//         },
//         {
//             "id": "67",
//             "label": "Estonia"
//         },
//         {
//             "id": "68",
//             "label": "Ethiopia"
//         },
//         {
//             "id": "69",
//             "label": "Falkland Islands (Malvinas)"
//         },
//         {
//             "id": "70",
//             "label": "Faroe Islands"
//         },
//         {
//             "id": "71",
//             "label": "Fiji"
//         },
//         {
//             "id": "72",
//             "label": "Finland"
//         },
//         {
//             "id": "73",
//             "label": "France"
//         },
//         {
//             "id": "74",
//             "label": "French Guiana"
//         },
//         {
//             "id": "75",
//             "label": "French Polynesia"
//         },
//         {
//             "id": "76",
//             "label": "French Southern Territories"
//         },
//         {
//             "id": "77",
//             "label": "Gabon"
//         },
//         {
//             "id": "78",
//             "label": "Gambia"
//         },
//         {
//             "id": "79",
//             "label": "Georgia"
//         },
//         {
//             "id": "80",
//             "label": "Germany"
//         },
//         {
//             "id": "81",
//             "label": "Ghana"
//         },
//         {
//             "id": "82",
//             "label": "Gibraltar"
//         },
//         {
//             "id": "83",
//             "label": "Greece"
//         },
//         {
//             "id": "84",
//             "label": "Greenland"
//         },
//         {
//             "id": "85",
//             "label": "Grenada"
//         },
//         {
//             "id": "86",
//             "label": "Guadeloupe"
//         },
//         {
//             "id": "87",
//             "label": "Guam"
//         },
//         {
//             "id": "88",
//             "label": "Guatemala"
//         },
//         {
//             "id": "89",
//             "label": "Guinea"
//         },
//         {
//             "id": "90",
//             "label": "Guinea-Bissau"
//         },
//         {
//             "id": "91",
//             "label": "Guyana"
//         },
//         {
//             "id": "92",
//             "label": "Haiti"
//         },
//         {
//             "id": "93",
//             "label": "Heard Island and Mcdonald Islands"
//         },
//         {
//             "id": "94",
//             "label": "Holy See (Vatican City State)"
//         },
//         {
//             "id": "95",
//             "label": "Honduras"
//         },
//         {
//             "id": "96",
//             "label": "Hong Kong"
//         },
//         {
//             "id": "97",
//             "label": "Hungary"
//         },
//         {
//             "id": "98",
//             "label": "Iceland"
//         },
//         {
//             "id": "99",
//             "label": "India"
//         },
//         {
//             "id": "100",
//             "label": "Indonesia"
//         },
//         {
//             "id": "101",
//             "label": "Iran, Islamic Republic of"
//         },
//         {
//             "id": "102",
//             "label": "Iraq"
//         },
//         {
//             "id": "103",
//             "label": "Ireland"
//         },
//         {
//             "id": "104",
//             "label": "Israel"
//         },
//         {
//             "id": "105",
//             "label": "Italy"
//         },
//         {
//             "id": "106",
//             "label": "Jamaica"
//         },
//         {
//             "id": "107",
//             "label": "Japan"
//         },
//         {
//             "id": "108",
//             "label": "Jordan"
//         },
//         {
//             "id": "109",
//             "label": "Kazakhstan"
//         },
//         {
//             "id": "110",
//             "label": "Kenya"
//         },
//         {
//             "id": "111",
//             "label": "Kiribati"
//         },
//         {
//             "id": "112",
//             "label": "Korea, Democratic People's Republic of"
//         },
//         {
//             "id": "113",
//             "label": "Korea, Republic of"
//         },
//         {
//             "id": "114",
//             "label": "Kuwait"
//         },
//         {
//             "id": "115",
//             "label": "Kyrgyzstan"
//         },
//         {
//             "id": "116",
//             "label": "Lao People's Democratic Republic"
//         },
//         {
//             "id": "117",
//             "label": "Latvia"
//         },
//         {
//             "id": "118",
//             "label": "Lebanon"
//         },
//         {
//             "id": "119",
//             "label": "Lesotho"
//         },
//         {
//             "id": "120",
//             "label": "Liberia"
//         },
//         {
//             "id": "121",
//             "label": "Libyan Arab Jamahiriya"
//         },
//         {
//             "id": "122",
//             "label": "Liechtenstein"
//         },
//         {
//             "id": "123",
//             "label": "Lithuania"
//         },
//         {
//             "id": "124",
//             "label": "Luxembourg"
//         },
//         {
//             "id": "125",
//             "label": "Macao"
//         },
//         {
//             "id": "126",
//             "label": "Macedonia, the Former Yugoslav Republic of"
//         },
//         {
//             "id": "127",
//             "label": "Madagascar"
//         },
//         {
//             "id": "128",
//             "label": "Malawi"
//         },
//         {
//             "id": "129",
//             "label": "Malaysia"
//         },
//         {
//             "id": "130",
//             "label": "Maldives"
//         },
//         {
//             "id": "131",
//             "label": "Mali"
//         },
//         {
//             "id": "132",
//             "label": "Malta"
//         },
//         {
//             "id": "133",
//             "label": "Marshall Islands"
//         },
//         {
//             "id": "134",
//             "label": "Martinique"
//         },
//         {
//             "id": "135",
//             "label": "Mauritania"
//         },
//         {
//             "id": "136",
//             "label": "Mauritius"
//         },
//         {
//             "id": "137",
//             "label": "Mayotte"
//         },
//         {
//             "id": "138",
//             "label": "Mexico"
//         },
//         {
//             "id": "139",
//             "label": "Micronesia, Federated States of"
//         },
//         {
//             "id": "140",
//             "label": "Moldova, Republic of"
//         },
//         {
//             "id": "141",
//             "label": "Monaco"
//         },
//         {
//             "id": "142",
//             "label": "Mongolia"
//         },
//         {
//             "id": "143",
//             "label": "Montserrat"
//         },
//         {
//             "id": "144",
//             "label": "Morocco"
//         },
//         {
//             "id": "145",
//             "label": "Mozambique"
//         },
//         {
//             "id": "146",
//             "label": "Myanmar"
//         },
//         {
//             "id": "147",
//             "label": "Namibia"
//         },
//         {
//             "id": "148",
//             "label": "Nauru"
//         },
//         {
//             "id": "149",
//             "label": "Nepal"
//         },
//         {
//             "id": "150",
//             "label": "Netherlands"
//         },
//         {
//             "id": "151",
//             "label": "Netherlands Antilles"
//         },
//         {
//             "id": "152",
//             "label": "New Caledonia"
//         },
//         {
//             "id": "153",
//             "label": "New Zealand"
//         },
//         {
//             "id": "154",
//             "label": "Nicaragua"
//         },
//         {
//             "id": "155",
//             "label": "Niger"
//         },
//         {
//             "id": "156",
//             "label": "Nigeria"
//         },
//         {
//             "id": "157",
//             "label": "Niue"
//         },
//         {
//             "id": "158",
//             "label": "Norfolk Island"
//         },
//         {
//             "id": "159",
//             "label": "Northern Mariana Islands"
//         },
//         {
//             "id": "160",
//             "label": "Norway"
//         },
//         {
//             "id": "161",
//             "label": "Oman"
//         },
//         {
//             "id": "162",
//             "label": "Pakistan"
//         },
//         {
//             "id": "163",
//             "label": "Palau"
//         },
//         {
//             "id": "164",
//             "label": "Palestinian Territory, Occupied"
//         },
//         {
//             "id": "165",
//             "label": "Panama"
//         },
//         {
//             "id": "166",
//             "label": "Papua New Guinea"
//         },
//         {
//             "id": "167",
//             "label": "Paraguay"
//         },
//         {
//             "id": "168",
//             "label": "Peru"
//         },
//         {
//             "id": "169",
//             "label": "Philippines"
//         },
//         {
//             "id": "170",
//             "label": "Pitcairn"
//         },
//         {
//             "id": "171",
//             "label": "Poland"
//         },
//         {
//             "id": "172",
//             "label": "Portugal"
//         },
//         {
//             "id": "173",
//             "label": "Puerto Rico"
//         },
//         {
//             "id": "174",
//             "label": "Qatar"
//         },
//         {
//             "id": "175",
//             "label": "Reunion"
//         },
//         {
//             "id": "176",
//             "label": "Romania"
//         },
//         {
//             "id": "177",
//             "label": "Russian Federation"
//         },
//         {
//             "id": "178",
//             "label": "Rwanda"
//         },
//         {
//             "id": "179",
//             "label": "Saint Helena"
//         },
//         {
//             "id": "180",
//             "label": "Saint Kitts and Nevis"
//         },
//         {
//             "id": "181",
//             "label": "Saint Lucia"
//         },
//         {
//             "id": "182",
//             "label": "Saint Pierre and Miquelon"
//         },
//         {
//             "id": "183",
//             "label": "Saint Vincent and the Grenadines"
//         },
//         {
//             "id": "184",
//             "label": "Samoa"
//         },
//         {
//             "id": "185",
//             "label": "San Marino"
//         },
//         {
//             "id": "186",
//             "label": "Sao Tome and Principe"
//         },
//         {
//             "id": "187",
//             "label": "Saudi Arabia"
//         },
//         {
//             "id": "188",
//             "label": "Senegal"
//         },
//         {
//             "id": "189",
//             "label": "Serbia and Montenegro"
//         },
//         {
//             "id": "190",
//             "label": "Seychelles"
//         },
//         {
//             "id": "191",
//             "label": "Sierra Leone"
//         },
//         {
//             "id": "192",
//             "label": "Singapore"
//         },
//         {
//             "id": "193",
//             "label": "Slovakia"
//         },
//         {
//             "id": "194",
//             "label": "Slovenia"
//         },
//         {
//             "id": "195",
//             "label": "Solomon Islands"
//         },
//         {
//             "id": "196",
//             "label": "Somalia"
//         },
//         {
//             "id": "197",
//             "label": "South Africa"
//         },
//         {
//             "id": "198",
//             "label": "South Georgia and the South Sandwich Islands"
//         },
//         {
//             "id": "199",
//             "label": "Spain"
//         },
//         {
//             "id": "200",
//             "label": "Sri Lanka"
//         },
//         {
//             "id": "201",
//             "label": "Sudan"
//         },
//         {
//             "id": "202",
//             "label": "Suriname"
//         },
//         {
//             "id": "203",
//             "label": "Svalbard and Jan Mayen"
//         },
//         {
//             "id": "204",
//             "label": "Swaziland"
//         },
//         {
//             "id": "205",
//             "label": "Sweden"
//         },
//         {
//             "id": "206",
//             "label": "Switzerland"
//         },
//         {
//             "id": "207",
//             "label": "Syrian Arab Republic"
//         },
//         {
//             "id": "208",
//             "label": "Taiwan, Province of China"
//         },
//         {
//             "id": "209",
//             "label": "Tajikistan"
//         },
//         {
//             "id": "210",
//             "label": "Tanzania, United Republic of"
//         },
//         {
//             "id": "211",
//             "label": "Thailand"
//         },
//         {
//             "id": "212",
//             "label": "Timor-Leste"
//         },
//         {
//             "id": "213",
//             "label": "Togo"
//         },
//         {
//             "id": "214",
//             "label": "Tokelau"
//         },
//         {
//             "id": "215",
//             "label": "Tonga"
//         },
//         {
//             "id": "216",
//             "label": "Trinidad and Tobago"
//         },
//         {
//             "id": "217",
//             "label": "Tunisia"
//         },
//         {
//             "id": "218",
//             "label": "Turkey"
//         },
//         {
//             "id": "219",
//             "label": "Turkmenistan"
//         },
//         {
//             "id": "220",
//             "label": "Turks and Caicos Islands"
//         },
//         {
//             "id": "221",
//             "label": "Tuvalu"
//         },
//         {
//             "id": "222",
//             "label": "Uganda"
//         },
//         {
//             "id": "223",
//             "label": "Ukraine"
//         },
//         {
//             "id": "224",
//             "label": "United Arab Emirates"
//         },
//         {
//             "id": "225",
//             "label": "United Kingdom"
//         },
//         {
//             "id": "226",
//             "label": "United States"
//         },
//         {
//             "id": "227",
//             "label": "United States Minor Outlying Islands"
//         },
//         {
//             "id": "228",
//             "label": "Uruguay"
//         },
//         {
//             "id": "229",
//             "label": "Uzbekistan"
//         },
//         {
//             "id": "230",
//             "label": "Vanuatu"
//         },
//         {
//             "id": "231",
//             "label": "Venezuela"
//         },
//         {
//             "id": "232",
//             "label": "Viet Nam"
//         },
//         {
//             "id": "233",
//             "label": "Virgin Islands, British"
//         },
//         {
//             "id": "234",
//             "label": "Virgin Islands, U.s."
//         },
//         {
//             "id": "235",
//             "label": "Wallis and Futuna"
//         },
//         {
//             "id": "236",
//             "label": "Western Sahara"
//         },
//         {
//             "id": "237",
//             "label": "Yemen"
//         },
//         {
//             "id": "238",
//             "label": "Zambia"
//         },
//         {
//             "id": "239",
//             "label": "Zimbabwe"
//         }
//     ],
//     "fuoriSede": [
//         {
//             "id": "1",
//             "label": "Si"
//         },
//         {
//             "id": "2",
//             "label": "No"
//         }
//     ],
//     "provincia": [
//         {
//             "id": "1",
//             "label": "Torino"
//         },
//         {
//             "id": "2",
//             "label": "Vercelli"
//         },
//         {
//             "id": "3",
//             "label": "Novara"
//         },
//         {
//             "id": "4",
//             "label": "Cuneo"
//         },
//         {
//             "id": "5",
//             "label": "Asti"
//         },
//         {
//             "id": "6",
//             "label": "Alessandria"
//         },
//         {
//             "id": "7",
//             "label": "Valle d'Aosta / Vallée d'Aoste"
//         },
//         {
//             "id": "8",
//             "label": "Imperia"
//         },
//         {
//             "id": "9",
//             "label": "Savona"
//         },
//         {
//             "id": "10",
//             "label": "Genova"
//         },
//         {
//             "id": "11",
//             "label": "La Spezia"
//         },
//         {
//             "id": "12",
//             "label": "Varese"
//         },
//         {
//             "id": "13",
//             "label": "Como"
//         },
//         {
//             "id": "14",
//             "label": "Sondrio"
//         },
//         {
//             "id": "15",
//             "label": "Milano"
//         },
//         {
//             "id": "16",
//             "label": "Bergamo"
//         },
//         {
//             "id": "17",
//             "label": "Brescia"
//         },
//         {
//             "id": "18",
//             "label": "Pavia"
//         },
//         {
//             "id": "19",
//             "label": "Cremona"
//         },
//         {
//             "id": "20",
//             "label": "Mantova"
//         },
//         {
//             "id": "21",
//             "label": "Bolzano / Bozen"
//         },
//         {
//             "id": "22",
//             "label": "Trento"
//         },
//         {
//             "id": "23",
//             "label": "Verona"
//         },
//         {
//             "id": "24",
//             "label": "Vicenza"
//         },
//         {
//             "id": "25",
//             "label": "Belluno"
//         },
//         {
//             "id": "26",
//             "label": "Treviso"
//         },
//         {
//             "id": "27",
//             "label": "Venezia"
//         },
//         {
//             "id": "28",
//             "label": "Padova"
//         },
//         {
//             "id": "29",
//             "label": "Rovigo"
//         },
//         {
//             "id": "30",
//             "label": "Udine"
//         },
//         {
//             "id": "31",
//             "label": "Gorizia"
//         },
//         {
//             "id": "32",
//             "label": "Trieste"
//         },
//         {
//             "id": "33",
//             "label": "Piacenza"
//         },
//         {
//             "id": "34",
//             "label": "Parma"
//         },
//         {
//             "id": "35",
//             "label": "Reggio nell'Emilia"
//         },
//         {
//             "id": "36",
//             "label": "Modena"
//         },
//         {
//             "id": "37",
//             "label": "Bologna"
//         },
//         {
//             "id": "38",
//             "label": "Ferrara"
//         },
//         {
//             "id": "39",
//             "label": "Ravenna"
//         },
//         {
//             "id": "40",
//             "label": "Forlì-Cesena"
//         },
//         {
//             "id": "41",
//             "label": "Pesaro e Urbino"
//         },
//         {
//             "id": "42",
//             "label": "Ancona"
//         },
//         {
//             "id": "43",
//             "label": "Macerata"
//         },
//         {
//             "id": "44",
//             "label": "Ascoli Piceno"
//         },
//         {
//             "id": "45",
//             "label": "Massa-Carrara"
//         },
//         {
//             "id": "46",
//             "label": "Lucca"
//         },
//         {
//             "id": "47",
//             "label": "Pistoia"
//         },
//         {
//             "id": "48",
//             "label": "Firenze"
//         },
//         {
//             "id": "49",
//             "label": "Livorno"
//         },
//         {
//             "id": "50",
//             "label": "Pisa"
//         },
//         {
//             "id": "51",
//             "label": "Arezzo"
//         },
//         {
//             "id": "52",
//             "label": "Siena"
//         },
//         {
//             "id": "53",
//             "label": "Grosseto"
//         },
//         {
//             "id": "54",
//             "label": "Perugia"
//         },
//         {
//             "id": "55",
//             "label": "Terni"
//         },
//         {
//             "id": "56",
//             "label": "Viterbo"
//         },
//         {
//             "id": "57",
//             "label": "Rieti"
//         },
//         {
//             "id": "58",
//             "label": "Roma"
//         },
//         {
//             "id": "59",
//             "label": "Latina"
//         },
//         {
//             "id": "60",
//             "label": "Frosinone"
//         },
//         {
//             "id": "61",
//             "label": "Caserta"
//         },
//         {
//             "id": "62",
//             "label": "Benevento"
//         },
//         {
//             "id": "63",
//             "label": "Napoli"
//         },
//         {
//             "id": "64",
//             "label": "Avellino"
//         },
//         {
//             "id": "65",
//             "label": "Salerno"
//         },
//         {
//             "id": "66",
//             "label": "L'Aquila"
//         },
//         {
//             "id": "67",
//             "label": "Teramo"
//         },
//         {
//             "id": "68",
//             "label": "Pescara"
//         },
//         {
//             "id": "69",
//             "label": "Chieti"
//         },
//         {
//             "id": "70",
//             "label": "Campobasso"
//         },
//         {
//             "id": "71",
//             "label": "Foggia"
//         },
//         {
//             "id": "72",
//             "label": "Bari"
//         },
//         {
//             "id": "73",
//             "label": "Taranto"
//         },
//         {
//             "id": "74",
//             "label": "Brindisi"
//         },
//         {
//             "id": "75",
//             "label": "Lecce"
//         },
//         {
//             "id": "76",
//             "label": "Potenza"
//         },
//         {
//             "id": "77",
//             "label": "Matera"
//         },
//         {
//             "id": "78",
//             "label": "Cosenza"
//         },
//         {
//             "id": "79",
//             "label": "Catanzaro"
//         },
//         {
//             "id": "80",
//             "label": "Reggio di Calabria"
//         },
//         {
//             "id": "81",
//             "label": "Trapani"
//         },
//         {
//             "id": "82",
//             "label": "Palermo"
//         },
//         {
//             "id": "83",
//             "label": "Messina"
//         },
//         {
//             "id": "84",
//             "label": "Agrigento"
//         },
//         {
//             "id": "85",
//             "label": "Caltanissetta"
//         },
//         {
//             "id": "86",
//             "label": "Enna"
//         },
//         {
//             "id": "87",
//             "label": "Catania"
//         },
//         {
//             "id": "88",
//             "label": "Ragusa"
//         },
//         {
//             "id": "89",
//             "label": "Siracusa"
//         },
//         {
//             "id": "90",
//             "label": "Sassari"
//         },
//         {
//             "id": "91",
//             "label": "Nuoro"
//         },
//         {
//             "id": "92",
//             "label": "Cagliari"
//         },
//         {
//             "id": "93",
//             "label": "Pordenone"
//         },
//         {
//             "id": "94",
//             "label": "Isernia"
//         },
//         {
//             "id": "95",
//             "label": "Oristano"
//         },
//         {
//             "id": "96",
//             "label": "Biella"
//         },
//         {
//             "id": "97",
//             "label": "Lecco"
//         },
//         {
//             "id": "98",
//             "label": "Lodi"
//         },
//         {
//             "id": "99",
//             "label": "Rimini"
//         },
//         {
//             "id": "100",
//             "label": "Prato"
//         },
//         {
//             "id": "101",
//             "label": "Crotone"
//         },
//         {
//             "id": "102",
//             "label": "Vibo Valentia"
//         },
//         {
//             "id": "103",
//             "label": "Verbano-Cusio-Ossola"
//         },
//         {
//             "id": "104",
//             "label": "Olbia-Tempio"
//         },
//         {
//             "id": "105",
//             "label": "Ogliastra"
//         },
//         {
//             "id": "106",
//             "label": "Medio Campidano"
//         },
//         {
//             "id": "107",
//             "label": "Carbonia-Iglesias"
//         },
//         {
//             "id": "108",
//             "label": "Monza e della Brianza"
//         },
//         {
//             "id": "109",
//             "label": "Fermo"
//         },
//         {
//             "id": "110",
//             "label": "Barletta-Andria-Trani"
//         }
//     ],
//     "regione": [
//         {
//             "id": "1",
//             "label": "Piemonte"
//         },
//         {
//             "id": "2",
//             "label": "Valle d'Aosta"
//         },
//         {
//             "id": "3",
//             "label": "Lombardia"
//         },
//         {
//             "id": "4",
//             "label": "Trentino-Alto Adige"
//         },
//         {
//             "id": "5",
//             "label": "Veneto"
//         },
//         {
//             "id": "6",
//             "label": "Friuli-Venezia Giulia"
//         },
//         {
//             "id": "7",
//             "label": "Liguria"
//         },
//         {
//             "id": "8",
//             "label": "Emilia-Romagna"
//         },
//         {
//             "id": "9",
//             "label": "Toscana"
//         },
//         {
//             "id": "10",
//             "label": "Umbria"
//         },
//         {
//             "id": "11",
//             "label": "Marche"
//         },
//         {
//             "id": "12",
//             "label": "Lazio"
//         },
//         {
//             "id": "13",
//             "label": "Abruzzo"
//         },
//         {
//             "id": "14",
//             "label": "Molise"
//         },
//         {
//             "id": "15",
//             "label": "Campania"
//         },
//         {
//             "id": "16",
//             "label": "Puglia"
//         },
//         {
//             "id": "17",
//             "label": "Basilicata"
//         },
//         {
//             "id": "18",
//             "label": "Calabria"
//         },
//         {
//             "id": "19",
//             "label": "Sicilia"
//         },
//         {
//             "id": "20",
//             "label": "Sardegna"
//         }
//     ],
//     "tipoSoggettoSegnalante": [
//         {
//             "id": "1",
//             "label": "Banca"
//         },
//         {
//             "id": "2",
//             "label": "Sim"
//         },
//         {
//             "id": "3",
//             "label": "SGR"
//         },
//         {
//             "id": "4",
//             "label": "Società di gestione di una sede regolamentata"
//         },
//         {
//             "id": "5",
//             "label": "Internalizzatore sistematico"
//         },
//         {
//             "id": "6",
//             "label": "Società non finanziaria"
//         },
//         {
//             "id": "7",
//             "label": "Fiduciaria"
//         },
//         {
//             "id": "8",
//             "label": "Altro"
//         }
//     ],
//     "vesteSegnalante": [
//         {
//             "id" : "1",
//             "label": "Conto Terzi"
//         },
//         {
//             "id" : "2",
//             "label": "Conto Proprio"
//         },
//         {
//             "id" : "3",
//             "label": "Gestore di sede di negoziazione"
//         },
//         {
//             "id" : "4",
//             "label": "Internalizzatore sistematico"
//         },
//         {
//             "id" : "5",
//             "label": "Altro (specificare nelle Note)"
//         },
//     //     {
//     //         "id": "1",
//     //         "label": "Intermediario - C/terzi"
//     //     },
//     //     {
//     //         "id": "2",
//     //         "label": "Intermediario - C/proprio (no clienti)"
//     //     },
//     //     {
//     //         "id": "3",
//     //         "label": "Intermediario - C/proprio (altro)"
//     //     },
//     //     {
//     //         "id": "4",
//     //         "label": "Società di gestione di un MR"
//     //     },
//     //     {
//     //         "id": "5",
//     //         "label": "Società di gestione di un MTF"
//     //     },
//     //     {
//     //         "id": "6",
//     //         "label": "Internalizzatore sistematico"
//     //     },
//     //     {
//     //         "id": "7",
//     //         "label": "Autorità estera ESMA"
//     //     },
//     //     {
//     //         "id": "8",
//     //         "label": "Autorità estera NO ESMA"
//     //     },
//     //     {
//     //         "id": "9",
//     //         "label": "Privato"
//     //     },
//     //     {
//     //         "id": "10",
//     //         "label": "Emittente"
//     //     },
//     //     {
//     //         "id": "11",
//     //         "label": "Altro (specificare nelle Note)"
//     //     }
//     ],
//     "catTipologiaNegoziazione": [
//         {
//             "id": "1",
//             "label": "Market Making"
//         },
//         {
//             "id": "2",
//             "label": "Arbitraggio"
//         }
//     ],
//     "catTipologiaStrumNegoziato": [
//         {
//             "id": "1",
//             "label": "Azioni"
//         },
//         {
//             "id": "2",
//             "label": "Derivati"
//         },
//         {
//             "id": "4",
//             "label": "Obbligazioni"
//         },
//         {
//             "id": "5",
//             "label": "Altro"
//         },
//         {
//             "id": "6",
//             "label": "Combinazione di più strumenti"
//         },
//         {
//             "id": "7",
//             "label": "ETPs / strutturati"
//         }
//     ]
// }

// export default SegnalazioneChoiceLists;
